"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import styles from './Footer.module.scss.mjs';
import { PaginationInfos } from './components/PaginationInfos/PaginationInfos.mjs';
import { ShowNextBatchButton } from './components/ShowNextBatchButton/ShowNextBatchButton.mjs';
import DivView from '../../../../views/DivView.mjs';

const Footer = () => {
  return /* @__PURE__ */ jsxs(DivView, { className: styles.footer, children: [
    /* @__PURE__ */ jsx(PaginationInfos, {}),
    /* @__PURE__ */ jsx(ShowNextBatchButton, {})
  ] });
};

export { Footer, Footer as default };
//# sourceMappingURL=Footer.mjs.map
